Attributes of the application questionnaire.
